import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function getDepartmentsUserData(cliendId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Department/list/${cliendId}`
    );

    if (res.data.length === 0) {
      return {
        success: false,
        message: "No hay departamentos que mostrar o no tiene los permisos.",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo datos de departamentos",
    };
  }
}

export async function getRolesData() {
  const type = 1;
  console.log("Fetching roles for type:", type);
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/User/role/list/${type}`
    );

    if (res.data.length === 0) {
      return {
        success: false,
        message: "No hay Roles que mostrar o no tiene los permisos.",
        data: [],
      };
    }
    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo datos de los Roles",
    };
  }
}

export async function getClientsData() {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Client/list`
    );

    if (res.data.length === 0) {
      return {
        success: false,
        message:
          "No hay departamentos que mostrar o no cuenta con los permisos",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (error) {
    return {
      success: false,
      message: "Error extrayendo datos de clientes",
    };
  }
}

export async function createMultipleUsers(data) {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/User/CreateMultipleUsers`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

export async function getRoutinesByClientAndDay(
  idClient,
  idUser,
  day,
  timeRange,
  dateNow
) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Routine/ByClientAndDay?idclient=${idClient}&idUser=${idUser}&day=${day}&timeRange=${timeRange}&dateNow=${dateNow}`
    );

    if (res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No hay rutinas que mostrar para este usuario y día.",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo datos de rutinas por cliente y día",
    };
  }
}

export async function getRoutineCountByDay(idClient, idUser, day, dateNow) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Routine/CountByDay?idclient=${idClient}&idUser=${idUser}&day=${day}&dateNow=${dateNow}`
    );

    if (res.status === 204) {
      return [];
    }

    const payload = res.data?.responseObject ?? res.data;
    return Array.isArray(payload) ? payload : [];
  } catch (e) {
    return [];
  }
}

export async function CreateRoutineLogUser(
  idClient,
  emailUser,
  idRoutine,
  idVideo,
  completed,
  timeRange,
  duration
) {
  try {
    const data = {
      IdClient: idClient,
      EmailUser: emailUser,
      IdRoutine: idRoutine,
      IdVideo: idVideo,
      Completed: completed,
      TimeRange: timeRange,
      TimeStamp: new Date().toISOString(),
    };

    // Add duration if provided
    if (duration !== undefined && duration !== null && duration > 0) {
      data.Duration = duration;
    }

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/Routine/LogMetricByUser`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Log de rutina registrado exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

export async function getWeeklyChart(idClient, idUser, startDate, endDate) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Report/WeeklyChart/${idClient}/${idUser}?startDate=${startDate}&endDate=${endDate}`
    );

    if (!res.data.responseObject) {
      return {
        success: false,
        message: "No hay datos de métricas semanales disponibles.",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo datos de métricas semanales",
    };
  }
}

// ==================== NOTIFICATION SCHEDULES ====================

/**
 * Obtiene todas las notificaciones programadas de un cliente
 * @param {number} idClient - ID del cliente
 * @returns {Promise} - Lista de notificaciones programadas
 */
export async function getNotificationSchedulesByClient(idClient) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/client/${idClient}`
    );

    if (!res.data.responseObject || res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No hay notificaciones programadas para este cliente.",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo notificaciones programadas del cliente",
    };
  }
}

/**
 * Obtiene todas las notificaciones programadas de un departamento
 * @param {number} idDepartment - ID del departamento
 * @returns {Promise} - Lista de notificaciones programadas
 */
export async function getNotificationSchedulesByDepartment(idDepartment) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/department/${idDepartment}`
    );

    if (!res.data.responseObject || res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No hay notificaciones programadas para este departamento.",
        data: [],
      };
    }

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo notificaciones programadas del departamento",
    };
  }
}

/**
 * Obtiene una notificación programada por ID
 * @param {number} id - ID de la notificación
 * @returns {Promise} - Notificación programada
 */
export async function getNotificationScheduleById(id) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/${id}`
    );

    return res.data.responseObject;
  } catch (e) {
    return {
      success: false,
      message: "Error extrayendo la notificación programada",
    };
  }
}

/**
 * Crea una nueva notificación programada
 * @param {Object} notificationData - Datos de la notificación
 * @returns {Promise}
 */
export async function createNotificationSchedule(notificationData) {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules`,
      notificationData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Notificación programada creada exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Actualiza una notificación programada existente
 * @param {number} id - ID de la notificación
 * @param {Object} notificationData - Datos actualizados
 * @returns {Promise}
 */
export async function updateNotificationSchedule(id, notificationData) {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/${id}`,
      notificationData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Notificación programada actualizada exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Elimina una notificación programada
 * @param {number} id - ID de la notificación
 * @returns {Promise}
 */
export async function deleteNotificationSchedule(id) {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/${id}`
    );

    return {
      success: true,
      data: res.data,
      message: "Notificación programada eliminada exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Activa o desactiva una notificación programada
 * @param {number} id - ID de la notificación
 * @param {boolean} isActive - Estado activo/inactivo
 * @returns {Promise}
 */
export async function toggleNotificationSchedule(id, isActive) {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/schedules/${id}/toggle`,
      isActive,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: `Notificación ${
        isActive ? "activada" : "desactivada"
      } exitosamente`,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Pospone (snooze) una notificación push
 * @param {Object} snoozeData - Datos del snooze
 * @param {number} snoozeData.scheduleId - ID de la notificación programada original
 * @param {number} snoozeData.userId - ID del usuario que pospone
 * @param {number} snoozeData.snoozeMinutes - Minutos a posponer (15, 30)
 * @param {string} snoozeData.originalTitle - Título original de la notificación
 * @param {string} snoozeData.originalBody - Cuerpo original de la notificación
 * @param {Object} snoozeData.originalData - Data original de la notificación
 * @returns {Promise}
 */
export async function snoozeNotification(snoozeData) {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/PushNotification/snooze`,
      snoozeData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: `Notificación pospuesta por ${snoozeData.snoozeMinutes} minutos`,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Solicita recuperación de contraseña
 * @param {string} email - Email del usuario
 * @returns {Promise}
 */
export async function forgotPassword(email) {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/Auth/ForgotPassword`,
      { email: email },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Correo de recuperación enviado exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

// ==================== TICKETS ====================

/**
 * Crea un nuevo ticket con archivos adjuntos opcionales
 * @param {Object} ticketData - Datos del ticket
 * @param {string} ticketData.title - Título del ticket (5-100 chars)
 * @param {string} ticketData.category - Categoría (technical, content, access, performance, other)
 * @param {string} ticketData.description - Descripción detallada (10-1000 chars)
 * @param {number} ticketData.status - Estado (0=Nuevo, 1=EnProgreso, 2=Resuelto, 3=Cerrado)
 * @param {number} ticketData.priority - Prioridad (0=Baja, 1=Media, 2=Alta, 3=Urgente)
 * @param {number} ticketData.clientId - ID del cliente (opcional)
 * @param {number} ticketData.userId - ID del usuario (opcional)
 * @param {Array<File>} files - Array de archivos adjuntos (opcional, max 5)
 * @returns {Promise}
 */
export async function createTicket(ticketData, files = []) {
  try {
    // Crear FormData para enviar archivos
    const formData = new FormData();

    // Agregar datos del ticket
    formData.append("Title", ticketData.title);
    formData.append("Category", ticketData.category); // Ya viene como número del enum (0-3)
    formData.append("Description", ticketData.description);
    formData.append("Status", ticketData.status || 0);
    formData.append("Priority", ticketData.priority || 1);

    if (ticketData.clientId) {
      formData.append("ClientId", ticketData.clientId);
    }

    if (ticketData.userId) {
      formData.append("UserId", ticketData.userId);
    }

    // Agregar archivos si existen
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("Files", file);
      });
    }

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Ticket creado exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene todos los tickets
 * @returns {Promise}
 */
export async function getAllTickets() {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/List`
    );

    if (!res.data.responseObject || res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No se encontraron tickets",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data.responseObject,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene tickets por cliente
 * @param {number} clientId - ID del cliente
 * @returns {Promise}
 */
export async function getTicketsByClient(clientId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/ByClient/${clientId}`
    );

    if (!res.data.responseObject || res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No se encontraron tickets para este cliente",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data.responseObject,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene tickets por cliente y usuario
 * @param {number} clientId - ID del cliente
 * @param {number} userId - ID del usuario
 * @returns {Promise}
 */
export async function getTicketsByClientAndUser(clientId, userId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/ByClientAndUser/${clientId}/${userId}`
    );

    if (!res.data.responseObject || res.data.responseObject.length === 0) {
      return {
        success: false,
        message: "No se encontraron tickets para este usuario",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data.responseObject,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene el historial de conversación de un ticket
 * @param {number} ticketId - ID del ticket
 * @returns {Promise}
 */
export async function getTicketHistory(ticketId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}/History`
    );

    if (!res.data.responseObject) {
      return {
        success: false,
        message: "No se encontró historial para este ticket",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data.responseObject,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Crea una nueva entrada en el historial del ticket (comentario)
 * @param {number} ticketId - ID del ticket
 * @param {Object} historyData - Datos del comentario
 * @param {Array} files - Archivos adjuntos (opcional)
 * @returns {Promise}
 */
export async function createTicketHistory(ticketId, historyData, files = []) {
  try {
    const formData = new FormData();
    formData.append("UserId", historyData.userId);
    formData.append("UserName", historyData.userName);
    formData.append("CommentText", historyData.commentText);
    formData.append("IsAdmin", historyData.isAdmin || false);

    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("Files", file);
      });
    }

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}/History`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      data: res.data,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Actualiza un comentario del historial del ticket
 * @param {number} historyId - ID del comentario
 * @param {string} commentText - Nuevo texto del comentario
 * @returns {Promise}
 */
export async function updateTicketHistory(historyId, commentText) {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/History/${historyId}`,
      {
        commentText: commentText,
      }
    );

    return {
      success: true,
      data: res.data,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene un ticket específico por ID
 * @param {number} ticketId - ID del ticket
 * @returns {Promise}
 */
export async function getTicket(ticketId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}`
    );

    if (!res.data.responseObject) {
      return {
        success: false,
        message: "Ticket no encontrado",
        data: null,
      };
    }

    return {
      success: true,
      data: res.data.responseObject,
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Actualiza un ticket
 * @param {number} ticketId - ID del ticket
 * @param {Object} ticketData - Datos a actualizar
 * @returns {Promise}
 */
export async function updateTicket(ticketId, ticketData) {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}`,
      ticketData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: res.data,
      message: "Ticket actualizado exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Elimina un ticket
 * @param {number} ticketId - ID del ticket
 * @returns {Promise}
 */
export async function deleteTicket(ticketId) {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${ticketId}`
    );

    return {
      success: true,
      data: res.data,
      message: "Ticket eliminado exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene estadísticas generales de tickets
 * @returns {Promise}
 */
export async function getTicketStatistics() {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/Statistics`
    );

    return {
      success: true,
      data: res.data.responseObject,
      message: "Estadísticas obtenidas exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene estadísticas de tickets por cliente
 * @param {number} clientId - ID del cliente
 * @returns {Promise}
 */
export async function getTicketStatisticsByClient(clientId) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/Statistics/ByClient/${clientId}`
    );

    return {
      success: true,
      data: res.data.responseObject,
      message: "Estadísticas obtenidas exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene estadísticas de tickets por rango de fechas
 * @param {Date} startDate - Fecha de inicio
 * @param {Date} endDate - Fecha de fin
 * @returns {Promise}
 */
export async function getTicketStatisticsByDateRange(startDate, endDate) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/Statistics/ByDateRange`,
      {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        },
      }
    );

    return {
      success: true,
      data: res.data.responseObject,
      message: "Estadísticas obtenidas exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

/**
 * Obtiene estadísticas de tickets por cliente y rango de fechas
 * @param {number} clientId - ID del cliente
 * @param {Date} startDate - Fecha de inicio
 * @param {Date} endDate - Fecha de fin
 * @returns {Promise}
 */
export async function getTicketStatisticsByClientAndDateRange(clientId, startDate, endDate) {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/Ticket/Statistics/ByClient/${clientId}/DateRange`,
      {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        },
      }
    );

    return {
      success: true,
      data: res.data.responseObject,
      message: "Estadísticas obtenidas exitosamente",
    };
  } catch (ex) {
    if (ex.response) {
      return {
        success: false,
        status: ex.response.status,
        message: ex.response.data?.message || ex.response.statusText,
        data: ex.response.data,
      };
    } else if (ex.request) {
      return {
        success: false,
        message: "No hubo respuesta del servidor",
        error: ex.request,
      };
    } else {
      return {
        success: false,
        message: ex.message,
      };
    }
  }
}

export default apiClient;
